(function () {
  function init() {
    var localToggle = document.querySelector('.rsi-pdp-vat-toggle .toggle-checkbox');
    if (!localToggle) return;

    // The header's own "Ex VAT / Inc VAT" switch is rendered by the VAT &
    // Tax Switcher app (see config/settings_data.json, app embed
    // "vat-tax-switcher"), not by this theme. Placing a second, identical
    // instance of its markup on the PDP (sections/main-product.liquid)
    // does not make the app treat it as another view of the same state —
    // it only drives the instance(s) it renders itself. So this file does
    // not reimplement VAT math at all; it just forwards interaction
    // between the two toggles, using whichever "real" (app-rendered)
    // toggle(s) already work correctly.
    function getRealToggles() {
      return Array.prototype.filter.call(
        document.querySelectorAll('.tax-switcher .toggle-checkbox'),
        function (el) {
          return el !== localToggle;
        }
      );
    }

    var isForwarding = false;

    function syncLocalFromReal() {
      if (isForwarding) return;
      var real = getRealToggles()[0];
      if (real && localToggle.checked !== real.checked) {
        localToggle.checked = real.checked;
      }
    }

    // Local -> real: a genuine .click() on the real toggle fires whatever
    // native click/change handling the app itself listens for, so its
    // own (already-working) price rewriting runs — this file never
    // touches price text directly.
    localToggle.addEventListener('change', function () {
      var reals = getRealToggles();
      isForwarding = true;
      reals.forEach(function (real) {
        if (real.checked !== localToggle.checked) {
          real.click();
        }
      });
      isForwarding = false;
    });

    // Real -> local: the app's real toggle can mount after this script
    // runs (its own script is lazy-loaded via an initially empty
    // <script data-switcher-js> tag on the page) and its state can change
    // at any time from the header or the app's own popup. A cheap,
    // continuous poll is simpler and more reliable here than guessing
    // which internal DOM attribute or custom event the app uses.
    syncLocalFromReal();
    window.setInterval(syncLocalFromReal, 400);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
